"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('ui/itelematix/home/index',["require", "exports", "text!./index.html", "models/userIdentityModel", "context", "services/authenticationService", "scriptLoaders/bundleLoader"], function (require, exports, templateMarkup, userIdentityModel, context, authenticationService, bundleLoader) {
    "use strict";
    /// <amd-dependency path='text!./index.html' name='templateMarkup' />

    var Index = function () {
        function Index() {
            _classCallCheck(this, Index);

            this.isLoggedIn = userIdentityModel.isAuthenticated;
            this.requiresTwoFactor = userIdentityModel.requiresTwoFactor;
            this.hasClaims = userIdentityModel.hasClaims;
            this.applicationVersion = context.applicationVersion;
            this.recoveryCodes = userIdentityModel.recoveryCodes;
            this.useRecoveryCode = userIdentityModel.useRecoveryCode;
        }

        _createClass(Index, [{
            key: "hideRecoveryCodesPopup",
            value: function hideRecoveryCodesPopup() {
                this.recoveryCodes([]);
                if (userIdentityModel.isAuthenticated() === false) {
                    authenticationService.getManageInfo().done(function (manageInfoResponse) {
                        context.hereMapsApiKey = manageInfoResponse.hereMapsApiKey;
                        context.appBundleUrl = manageInfoResponse.appBundleUrl;
                        bundleLoader.loadBundleAsyncOnce().done(function () {
                            require(['app/startup'], function () {
                                userIdentityModel.setSessionId(manageInfoResponse.sessionId);
                                userIdentityModel.claims(manageInfoResponse.claims);
                                userIdentityModel.setUserName(manageInfoResponse.email);
                                userIdentityModel.setLocalLoginProvider(manageInfoResponse.localLoginProvider);
                                userIdentityModel.setInsurerId();
                                userIdentityModel.isAuthenticated(true);
                                userIdentityModel.requiresTwoFactor(false);
                                //this.checkingCredentials(false);
                                //this.gettingClaims(false);
                            });
                        });
                    }).fail(function (err) {
                        userIdentityModel.isAuthenticated(false);
                        //this.checkingCredentials(false);
                        //this.gettingClaims(false);
                    });
                }
            }
        }]);

        return Index;
    }();

    return { viewModel: Index, template: templateMarkup };
});
//# sourceMappingURL=index.js.map;
